import { useState, type FC } from "react";

import { Input } from "@/components/ui/input";

import { filterCategoryNames } from "./categoryFolders";

type Props = {
  names: string[];
  onPick: (name: string) => void;
};

/**
 * Searchable unused CaseBlink category names, listed alphabetically. Used
 * inside the New Folder menu and the tree's New folder submenu.
 */
export const CategoryFolderPicker: FC<Props> = ({ names, onPick }) => {
  const [query, setQuery] = useState("");
  const shown = filterCategoryNames(names, query).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );

  return (
    <div className="flex w-64 flex-col" data-testid="category-folder-picker">
      <div className="p-1">
        <Input
          aria-label="Filter Categories"
          placeholder="Filter categories…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.stopPropagation()}
        />
      </div>
      <div className="max-h-72 overflow-y-auto p-1">
        {shown.length ? (
          shown.map((name) => (
            <button
              key={name}
              type="button"
              role="menuitem"
              className="flex w-full rounded-md px-2 py-1.5 text-left text-sm text-fg hover:bg-fill-2"
              onClick={() => onPick(name)}
            >
              {name}
            </button>
          ))
        ) : (
          <p className="px-2 py-3 text-sm text-fg-3">
            {names.length ? "No category matches." : "No unused categories."}
          </p>
        )}
      </div>
    </div>
  );
};
